import { InjectionToken } from '@angular/core';

export const PRIZM_CONTEXT_KEY = new InjectionToken('token from prizm context');
